import { createStyles } from '@material-ui/styles';

export default (overrideClasses?: any) =>
  createStyles({
    icon: {
      marginRight: 5,
      marginTop: 5,
      fontSize: 16,
    },
    ...overrideClasses,
  });
